import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import KrimaanCropPlanner from './Frontend/components/KrimaanCropPlanner'
import LoginPage from './Frontend/components/LoginPage';
import RegisterPage from './Frontend/components/RegisterPage';
import FarmerInfoPage from './Frontend/components/FarmerInfoPage';
import CropRecommendation from './Frontend/components/CropRecommendation';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/"  element={<KrimaanCropPlanner/>} />
        <Route path="/login" element={<LoginPage/>} />
        <Route path="/register" element={<RegisterPage/>} />
        <Route path="/farmer/:id" element={<FarmerInfoPage/>} />
        <Route  path="/cropRecommendation/:id" element={<CropRecommendation/>} />
      </Routes>
    </Router>
  );
};

export default App;
